<template>
<div>
    <el-row class="cs-contentContainer">
        <el-col :span="4" class="cs-main-left-container">
            <navigator></navigator>
        </el-col>
        <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
            <div class="cs-fullHeight cs-contentContainer-right">
                <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
                    <el-row>
                        <el-col>
                            <span class="cs-title">课程安排</span>
                            <el-row class="grid-content">
                                <el-col>
                                    <teacherCourseReview :data="teacherData"></teacherCourseReview>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-col>
    </el-row>
</div>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
    .grid-content {
        margin-top: 15px;
        .cs-schedule-buttonContainer {
            text-align: right;
        }
    }
}
</style>

<script>
import navigator from "../../components/navigator";
import teacherCourseReview from "../../components/teacherCourseReview";
import {
    getCurrentTeacher
} from "../../service/teacherCourse.service.js"
export default {
    data() {
        return {
            loading: false,
            teacherData: {},
        };
    },
    components: {
        navigator,
        teacherCourseReview
    },
    computed: {},
    created() {
        this.loadTeacherData();
    },
    methods: {
        loadTeacherData() {
            getCurrentTeacher().then(result => {
                if (!!result && result.success) {
                    let data = {
                            teacherName: result.data.TeacherName,
                            teacherId: result.data.TeacherId,
                            termId: result.data.TermId
                        };
                        this.teacherData =data;
                    // this.teacherData.teacherName = result.data.TeacherName;
                    // this.teacherData.teacherId = result.data.TeacherId;
                    // this.teacherData.termId = result.data.TermId;
                } else {
                    this.$message.error(result.message);
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/page/teacher/schedule.vue